<template>
  <section class="roster">
    <header class="roster__head">
      <span class="gm-section-title">{{ title }}</span>
      <span class="roster__count">{{ characters.length }}</span>
    </header>
    <div v-if="characters.length > 0" class="roster__row gm-scroll">
      <CharacterCard
          v-for="character in characters"
          :key="character.id"
          :class="{ selected: character.id === selectedCharacterId }"
          :icon="character.biography?.avatar || ''"
          :name="character.name"
          :details="getCharDetails(character.id)"
          @click="toggleCharacter(character.id)"
      />
    </div>
    <div v-else class="gm-empty">
      <span class="gm-empty__hint">Nobody here</span>
    </div>
  </section>
</template>

<script>
import CharacterCard from './CharacterCard.vue';

export default {
  name: "CharacterCardHolder",
  components: { CharacterCard },
  props: {
    characters: { type: Array, required: true },
    selectedCharacterId: { type: String, default: null },
    title: { type: String, default: "Characters" },
    /* additionalCharactersData:
     * Additional character data to be displayed in the character card details
     * @type {Object}
     * {"f3c4216f-cbaa-4792-b6e6-1cedd502defe":{
     *     "id": "f3c4216f-cbaa-4792-b6e6-1cedd502defe",
     *     "name": "The Veiled Arbiter",
     *     "rank_grade": 2,
     *     "attributes": [
     *         {
     *             "name": "Health",
     *             "current": 59,
     *             "max": 90
     *         },
     *         {
     *             "name": "Energy",
     *             "current": 130,
     *             "max": 166
     *         },
     *         {
     *             "name": "Action Points",
     *             "current": 1196,
     *             "max": 12
     *         }
     *     ],
     *     "dimension": 1,
     *     "position": "00000000-0000-0000-0000-0193cb146bce",
     *     "coordinates": {
     *         "x": 2,
     *         "y": 1,
     *         "z": 1
     *     }
     * }}
     */
    additionalCharactersData: { type: Object, default: () => ({}) },
  },
  emits: ["characterSelected", "characterDeselected"],
  methods: {
    getCharDetails(charId) {
      return this.additionalCharactersData[charId] || {};
    },
    toggleCharacter(id) {
      if (id === this.selectedCharacterId) {
        this.deselectCharacter(id);
        return;
      }
      this.selectCharacter(id);
    },
    selectCharacter(id) {
      this.$emit("characterSelected", id);
    },
    deselectCharacter(id) {
      if (id === this.selectedCharacterId) {
        this.$emit("characterDeselected");
      }
    },
  },
};
</script>

<style scoped>
.roster {
  display: flex;
  flex-direction: column;
  gap: var(--gm-gap-xs);
  padding: var(--gm-gap-sm);
  background: var(--gm-surface-sunken);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius);
}

.roster__head {
  display: flex;
  align-items: center;
  gap: var(--gm-gap-sm);
}

.roster__head .gm-section-title {
  margin: 0;
}

.roster__count {
  font-family: var(--gm-font-display);
  font-size: 0.6rem;
  color: var(--gm-text-dim);
}

.roster__row {
  display: flex;
  gap: var(--gm-gap-sm);
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: var(--gm-gap-xs);
}
</style>
